<template>
  <div>
    <template v-if="$store.getters.user && Object.keys($store.getters.web_socket).length > 0 && !connecting">
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" color="primary" depressed>
            <template v-if="$store.getters.web_socket_access">
              <v-icon>mdi-network</v-icon>
            </template>
            <template v-else>
              <v-icon>mdi-network-outline</v-icon>
            </template>
            <v-icon>mdi-menu-down</v-icon>
          </v-btn>
        </template>

        <v-list>
          <template v-for="(socket, namespace) in $store.getters.web_socket">
            <v-list-item>
              <v-list-item-title>
                {{ $t("message.common.sid") }}({{ $t("message.web_socket.ws_" + namespace) }}):&nbsp;{{ socket.id }}
              </v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item @click="disconnect()">
            <v-list-item-action>
              <v-icon>mdi-close-network-outline</v-icon>
            </v-list-item-action>
            <v-list-item-title>
              {{ $t("message.web_socket.disconnect_websocket") }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
    <template v-else>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" class="ma-2" @click="connecting = true; connect()" :disabled="$store.getters.user === null || connecting">
            mdi-network-off-outline
          </v-icon>
        </template>
        <span>{{ $t("message.web_socket.connect_websocket") }}</span>
      </v-tooltip>
    </template>
  </div>
</template>

<script>
import { web_socket } from "../js/web_socket";
import { get_eid } from "../js/get_eid";

export default {
  name: 'web_socket',
  data: function(){
    return {
      module_id: "87",
      connecting: false
    }
  },
  mixins: [web_socket, get_eid]
}
</script>
